import { createContext } from 'react';

export const FormContext = createContext<{
  control: any;
  setValue?: (name: any, value: any) => void;
  watch?: any;
}>({
  control: null,
  setValue: null,
  watch: null,
});
